// Nome e versione dell'SDK, inviati in `sdk.{name,version}` di ogni payload e
// nello `User-Agent`. Tenere `SDK_VERSION` allineata a `version` in package.json.
export const SDK_NAME = 'closeyourit-js'
export const SDK_VERSION = '0.10.0'

// `platform` degli eventi Sentry e `contexts.runtime.name`.
export const PLATFORM = 'javascript'
